import React from "react";
import { useLoaderData, useNavigate } from "react-router-dom";

const EventProductDetails = () => {
  const product = useLoaderData();
  const navigate = useNavigate();

  const closeModal = () => {
    navigate(-1); // Go back to the previous page
  };

  return (
    <div className="modal">
      <div className="modal-content">
        <span className="close" onClick={closeModal}>Close</span>
        <h2>{product.title}</h2>
        <p>Product ID: {product._id}</p>
        {/* Add other product details here */}
      </div>
    </div>
  );
};

export default EventProductDetails;
